import React from 'react';
import { useTranslation } from 'react-i18next';
import TaListReportPage from './components/TaListReportPage';
import { useShiftReport } from './config/shiftReport';

// AKM POC §7.4 — Vardiya Raporu.
export default function ShiftReportPage() {
  const { t } = useTranslation();
  const report = useShiftReport();
  return (
    <TaListReportPage
      title={t('taReports.shiftReport.title')}
      report={report}
      exportUrl="/v1/ta/reports/shift-report/export"
    />
  );
}
